// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'toolbox-wrench';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.688 5.063H1.313a.75.75 0 0 0-.75.75v9.75c0 .414.335.75.75.75h15.374a.75.75 0 0 0 .75-.75v-9.75a.75.75 0 0 0-.75-.75z' />
    <path d='M12.938 5.063v-2.25a1.125 1.125 0 0 0-1.126-1.126H6.189a1.125 1.125 0 0 0-1.125 1.125v2.25m7.874 3.376A2.24 2.24 0 0 0 11 9.562H7a2.25 2.25 0 1 0 0 2.25h4a2.246 2.246 0 1 0 1.938-3.374zm-10.125 2.25h2.25m7.875 0h2.25' />
  </g>
);

export const viewBox = '0 0 18 18';
